import gql from 'graphql-tag';
import { OrganizationId, VisitorData, VisitorDataStub, IInterval } from '@kaizenplatform/intelligence-entity';
import GraphQLClient from '../../adapter/GraphQLClient';
import sleep from '../../utility/sleep';

class VisitorWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public visitorsStub = async (): Promise<VisitorData> => {
    await sleep(2000);
    return new VisitorDataStub();
  };

  public visitors = async (organizationId: OrganizationId, periods: IInterval[]): Promise<VisitorData> => {
    const result = await this.graphqlClient.query(
      gql`
        query visitors($organizationId: ID!, $periods: [IntervalInput!]!) {
          visitors(organizationId: $organizationId, periods: $periods) {
            daily {
              label
              values {
                datetime
                value
              }
            }
            weekly {
              label
              values {
                datetime
                value
              }
            }
            monthly {
              label
              values {
                datetime
                value
              }
            }
          }
        }
      `,
      {
        organizationId,
        periods,
      },
    );

    return VisitorData.fromJSON(result.visitors);
  };

  public visitorsBySalesRateStub = async (): Promise<VisitorData> => {
    await sleep(2000);
    return new VisitorDataStub();
  };

  public purchasers = async (organizationId: OrganizationId, periods: IInterval[]): Promise<VisitorData> => {
    const result = await this.graphqlClient.query(
      gql`
        query purchasers($organizationId: ID!, $periods: [IntervalInput!]!) {
          purchasers(organizationId: $organizationId, periods: $periods) {
            daily {
              label
              values {
                datetime
                value
              }
            }
            weekly {
              label
              values {
                datetime
                value
              }
            }
            monthly {
              label
              values {
                datetime
                value
              }
            }
          }
        }
      `,
      {
        organizationId,
        periods,
      },
    );

    return VisitorData.fromJSON(result.purchasers);
  };
  public purchaseRates = async (organizationId: OrganizationId, periods: IInterval[]): Promise<VisitorData> => {
    const result = await this.graphqlClient.query(
      gql`
        query purchaseRates($organizationId: ID!, $periods: [IntervalInput!]!) {
          purchaseRates(organizationId: $organizationId, periods: $periods) {
            daily {
              label
              values {
                datetime
                value
              }
            }
            weekly {
              label
              values {
                datetime
                value
              }
            }
            monthly {
              label
              values {
                datetime
                value
              }
            }
          }
        }
      `,
      {
        organizationId,
        periods,
      },
    );

    return VisitorData.fromJSON(result.purchaseRates);
  };

  public visitorsBySessionStub = async (): Promise<VisitorData> => {
    await sleep(2000);
    return new VisitorDataStub();
  };

  public visitorsBySession = async (organizationId: OrganizationId, periods: IInterval[]): Promise<VisitorData> => {
    const result = await this.graphqlClient.query(
      gql`
        query visitorsBySession($organizationId: ID!, $periods: [IntervalInput!]!) {
          visitorsBySession(organizationId: $organizationId, periods: $periods) {
            daily {
              label
              values {
                datetime
                value
              }
            }
            weekly {
              label
              values {
                datetime
                value
              }
            }
            monthly {
              label
              values {
                datetime
                value
              }
            }
          }
        }
      `,
      {
        organizationId,
        periods,
      },
    );

    return VisitorData.fromJSON(result.visitorsBySession);
  };

  public visitorsByPvStub = async (): Promise<VisitorData> => {
    await sleep(2000);
    return new VisitorDataStub();
  };

  public visitorsByPv = async (organizationId: OrganizationId, periods: IInterval[]): Promise<VisitorData> => {
    const result = await this.graphqlClient.query(
      gql`
        query visitorsByPv($organizationId: ID!, $periods: [IntervalInput!]!) {
          visitorsByPv(organizationId: $organizationId, periods: $periods) {
            daily {
              label
              values {
                datetime
                value
              }
            }
            weekly {
              label
              values {
                datetime
                value
              }
            }
            monthly {
              label
              values {
                datetime
                value
              }
            }
          }
        }
      `,
      {
        organizationId,
        periods,
      },
    );

    return VisitorData.fromJSON(result.visitorsByPv);
  };
}

export default VisitorWebApi;
